import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { UserCog } from 'lucide-react';

const VehicleEditForm = ({ vehicle, onSave, onCancel }) => {
  const [form, setForm] = useState({
    plate: vehicle.plate || '', brand: vehicle.brand || '', model: vehicle.model || '',
    year: vehicle.year || '', color: vehicle.color || '', notes: vehicle.notes || '',
  });
  return (
    <div className="space-y-3">
      <div className="grid grid-cols-2 gap-2">
        <div><label className="text-gray-400 text-xs">Plaka</label><Input value={form.plate} onChange={e => setForm(f => ({ ...f, plate: e.target.value.toUpperCase() }))} className="bg-gray-800 border-gray-700 text-white h-8 text-sm" data-testid="edit-vehicle-plate" /></div>
        <div><label className="text-gray-400 text-xs">Marka</label><Input value={form.brand} onChange={e => setForm(f => ({ ...f, brand: e.target.value }))} className="bg-gray-800 border-gray-700 text-white h-8 text-sm" /></div>
        <div><label className="text-gray-400 text-xs">Model</label><Input value={form.model} onChange={e => setForm(f => ({ ...f, model: e.target.value }))} className="bg-gray-800 border-gray-700 text-white h-8 text-sm" /></div>
        <div><label className="text-gray-400 text-xs">Yil</label><Input type="number" value={form.year} onChange={e => setForm(f => ({ ...f, year: e.target.value }))} className="bg-gray-800 border-gray-700 text-white h-8 text-sm" /></div>
        <div><label className="text-gray-400 text-xs">Renk</label><Input value={form.color} onChange={e => setForm(f => ({ ...f, color: e.target.value }))} className="bg-gray-800 border-gray-700 text-white h-8 text-sm" /></div>
      </div>
      <div><label className="text-gray-400 text-xs">Notlar</label><Input value={form.notes} onChange={e => setForm(f => ({ ...f, notes: e.target.value }))} className="bg-gray-800 border-gray-700 text-white h-8 text-sm" placeholder="Arac hakkinda notlar..." /></div>
      <div className="flex gap-2 pt-1">
        <Button onClick={onCancel} variant="outline" className="flex-1 border-gray-600 text-gray-300">Iptal</Button>
        <Button onClick={() => { const d = {}; Object.entries(form).forEach(([k,v]) => { if (k==='year' && v) d[k]=parseInt(v); else if (v) d[k]=v; }); onSave(d); }} className="flex-1 bg-blue-600 hover:bg-blue-700 text-white" data-testid="save-vehicle-edit-btn">Kaydet</Button>
      </div>
    </div>
  );
};

export const VehicleEditDialog = ({ editingVehicle, setEditingVehicle, onSave }) => {
  if (!editingVehicle) return null;
  return (
    <Dialog open={true} onOpenChange={() => setEditingVehicle(null)}>
      <DialogContent className="bg-gray-900 border-gray-700 max-w-md">
        <DialogHeader><DialogTitle className="text-white">Arac Duzenle - {editingVehicle.plate}</DialogTitle></DialogHeader>
        <VehicleEditForm vehicle={editingVehicle} onSave={onSave} onCancel={() => setEditingVehicle(null)} />
      </DialogContent>
    </Dialog>
  );
};

export const VehicleTransferDialog = ({ transferVehicle, setTransferVehicle, transferTargetId, setTransferTargetId, customers, onTransfer }) => {
  if (!transferVehicle) return null;
  return (
    <Dialog open={true} onOpenChange={() => setTransferVehicle(null)}>
      <DialogContent className="bg-gray-900 border-gray-700 max-w-md">
        <DialogHeader><DialogTitle className="text-white flex items-center gap-2"><UserCog className="h-5 w-5 text-yellow-500" />Arac Transfer - {transferVehicle.plate}</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div className="bg-yellow-900/20 border border-yellow-700/40 rounded-lg p-3 text-yellow-300 text-xs">
            Eski isler orijinal musteride kalir. Sadece aracin sahipligi degisir.
          </div>
          <div className="bg-gray-800 rounded p-2">
            <p className="text-gray-400 text-xs">Mevcut Musteri</p>
            <p className="text-white text-sm font-semibold">{customers.find(c => c.id === transferVehicle.customerId)?.name || '-'}</p>
          </div>
          <div>
            <label className="text-gray-400 text-xs block mb-1">Hedef Musteri</label>
            <Select value={transferTargetId || "_none"} onValueChange={v => setTransferTargetId(v === '_none' ? '' : v)}>
              <SelectTrigger className="bg-gray-800 border-gray-700 text-white" data-testid="transfer-target-select"><SelectValue placeholder="Musteri secin" /></SelectTrigger>
              <SelectContent className="bg-gray-900 border-gray-700">
                <SelectItem value="_none" className="text-white hover:bg-gray-800">Musteri secin</SelectItem>
                {customers.filter(c => c.id !== transferVehicle.customerId).map(c => (
                  <SelectItem key={c.id} value={c.id} className="text-white hover:bg-gray-800">{c.name}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div className="flex gap-2 pt-2">
            <Button onClick={() => setTransferVehicle(null)} variant="outline" className="flex-1 border-gray-600 text-gray-300">Iptal</Button>
            <Button onClick={onTransfer} disabled={!transferTargetId}
              className="flex-1 bg-yellow-600 hover:bg-yellow-700 text-white" data-testid="confirm-transfer-btn">Transfer Et</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default VehicleEditForm;
